"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERAL = void 0;
exports.GENERAL = {
    EMAIL_TAKEN_BY_ACTIVE_USER: 'user:general:email_taken_by_active_user',
    EMAIL_TAKEN_BY_INACTIVE_USER: 'user:general:email_taken_by_inactive_user'
};
